import React, { useEffect, useState } from 'react';

const SystemMessageBubble = (props) => {
  const [isRight, setIsRight] = useState(false);
  const [bubbleContent, setBubbleContent] = useState(null);
  const [chatterSettings, setChatterSettings] = useState(null);
  
  useEffect(() => {
    setIsRight(props.isRight);
    setBubbleContent(props.bubbleContent);
    setChatterSettings(props.chatterSettings);
  }, [props]);

  if (bubbleContent === null) {
    return <></>;
  }

  return (chatterSettings?.classic_message_layout === true ?
    <div className="system-message-bubble-container flex">
      <div className="system-message-bubble-inner w-full flex flex-row mb-1">
        <div className="main flex flex-column">🔔 {bubbleContent.message}</div>
      </div>
    </div>
  :
    <div className="system-message-bubble-container flex">
      <div className="system-message-bubble-inner w-full flex flex-row justify-content-center pb-2">
        <div className="main flex flex-column text-xs text-500">{bubbleContent.message}</div>
      </div>
    </div>
  );
};
  
export default SystemMessageBubble;
